var map = {
	"./target_lv_1.png": 29865,
	"./target_lv_10.png": 39429,
	"./target_lv_2.png": 335,
	"./target_lv_3.png": 93740,
	"./target_lv_4.png": 68017,
	"./target_lv_5.png": 57997,
	"./target_lv_6.png": 91302,
	"./target_lv_7.png": 44440,
	"./target_lv_8.png": 62215,
	"./target_lv_9.png": 40387
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5763;